module.exports = __webpack_public_path__ + "media/images/flags/GB-WLS-d346be227b8a9ef26b528f346583c412.svg";